import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import st from './AddSkillsLevelModal.module.scss'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'

const AddSkillsLevelModal = ({ translate }) => {
  const { modalValues: modalValue, changeValue, check } = asideModalStore

  const handleInputChange = (e) => {
    const { value } = e.target
    changeValue(value, 'name')
  }

  return (
    <div className={st.fieldSet}>
      <FormField>
        <FormLabel isRequired>{translate.skill_levels}:</FormLabel>
        <FormInput isError={check('name')}>
          <input
            type='text'
            placeholder={translate.name}
            name='name'
            value={modalValue?.name || ''}
            onChange={handleInputChange}
            maxLength={35}
          />
        </FormInput>
      </FormField>
    </div>
  )
}

export default observer(AddSkillsLevelModal)
